import React from "react";
import ToggleButton from "../ToggleButton/ToggleButton";
import { Observer } from "mobx-react";

const SettingFamilyCard = ({
  family_data,
  getFamilyMemberImageFrom,
  width,
  handleToggle,
  isToggleDisable,
  setUserData,
  userData,
  data,
  isAllDis,
  borderObje,
}) => {
  return (
    <Observer>
      {() => (
        <div
          className="set_family_card"
          style={width !== undefined ? { width: width } : borderObje}
        >
          <div className="family_row">
            <p className="title1">All Members</p>{" "}
            <ToggleButton
              isToggleDisable={!isAllDis}
              handleToggle={(e, data) => handleToggle(e, data)}
              data={family_data}
              name={"All"}
            />
          </div>
          {family_data?.map((data, index) => {
            return (
              <div className="family_row_other">
                {data?.client?.profile_pic &&
                getFamilyMemberImageFrom?.[data?.client?.user_id] ? (
                  <img
                    className="member_profile_img"
                    height={41}
                    width={41}
                    src={
                      getFamilyMemberImageFrom
                        ? getFamilyMemberImageFrom[data.client.user_id]
                        : null
                    }
                    alt=""
                  />
                ) : (
                  <div className="no_imagg">
                    <p>{data?.client?.full_name?.split(" ")[0][0]}</p>
                  </div>
                )}
                <p className="title2">{data?.client?.full_name}</p>
                <ToggleButton
                  isToggleDisable={!data?.accessEnabled}
                  handleToggle={(e, data) => handleToggle(e, data)}
                  data={data}
                  name={Object.keys(isToggleDisable)[index]}
                />
              </div>
            );
          })}
        </div>
      )}
    </Observer>
  );
};

export default SettingFamilyCard;
